<script setup lang="js">
const props = defineProps({text:String})
</script>

<template>
  <div>
    <div class="w-full lg:my-20 md:my-10 my-10  border-s border-[#011A81] flex justify-center relative ">
      <div class="w-full bg-[#54C3F1]  h-[0.08rem] absolute translate-y-1/2 top-1/2"></div>
<!--      <el-image class="w-1/2 lg:w-1/4 bg-[#011A81] px-12" :src="dblogo"/>-->
      <div class="w-14 lg:w-20 md:w-14 bg-[#011A81] z-50"></div>
      <text class="text-3xl md:text-3xl lg:text-4xl text-white px-4 md:px-4 lg:px-8 py-3 bg-[#0049b9] rounded-full border border-[#707070] z-50 tracking-widest">{{text}}</text>
      <div class="w-14 lg:w-20 md:w-14 bg-[#011A81] z-50"></div>
    </div>
  </div>

</template>

<style scoped>

</style>
